import LoadingSpinner from '@common/src/components/LoadingSpinner';
import FlowProductsLayout from '@flows/src/components/flow-products/FlowProductsLayout';
import useFlowsProductSelectionStore from '@flows/src/store/zustand/flows-products/flowsProductSelectionStore';
import { ErrorBoundary } from '@sentry/react';
import { FC, lazy, Suspense, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router';
const FlowProductsOverview = lazy(
  () => import('@flows/src/pages/flow-products/FlowProductsOverview'),
);

export const FLOWS_PRODUCTS_PATH = '/flow-products';

const FlowsProductsRouter: FC = () => {
  const resetSelectionStore = useFlowsProductSelectionStore(
    (state) => state.reset,
  );
  useEffect(() => {
    resetSelectionStore();
    return () => {
      resetSelectionStore();
    };
  }, []);

  return (
    <ErrorBoundary>
      <FlowProductsLayout>
        <Switch>
          <Redirect
            from={`${FLOWS_PRODUCTS_PATH}/:flowId`}
            to={`${FLOWS_PRODUCTS_PATH}/:flowId/overview`}
            exact
          />
          <Route
            path={`${FLOWS_PRODUCTS_PATH}/:flowId/overview/:insuranceId?`}
            exact
            render={() => (
              <Suspense fallback={<LoadingSpinner />}>
                <FlowProductsOverview />
              </Suspense>
            )}
          />
          <Route
            path={`${FLOWS_PRODUCTS_PATH}/:flowId/basket`}
            render={() => (
              <Suspense fallback={<LoadingSpinner />}>
                <p>Anva basket</p>
              </Suspense>
            )}
          />
        </Switch>
      </FlowProductsLayout>
    </ErrorBoundary>
  );
};

export default FlowsProductsRouter;
